export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE";

export const GET_CATEGORIES_REQUEST = "GET_CATEGORIES_REQUEST";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_FAILURE = "GET_CATEGORIES_FAILURE";

export const GET_BRANDS_REQUEST = "GET_BRANDS_REQUEST";
export const GET_BRANDS_SUCCESS = "GET_BRANDS_SUCCESS";
export const GET_BRANDS_FAILURE = "GET_BRANDS_FAILURE";

export const GET_SOLO_PRODUCT_REQUEST = "GET_SOLO_PRODUCT_REQUEST";
export const GET_SOLO_PRODUCT_SUCCESS = "GET_SOLO_PRODUCT_SUCCESS";
export const GET_SOLO_PRODUCT_FAILURE = "GET_SOLO_PRODUCT_FAILURE";

//reviews
export const GET_PRODUCT_REVIEWS_REQUEST = "GET_PRODUCT_REVIEWS_REQUEST";
export const GET_PRODUCT_REVIEWS_SUCCESS = "GET_PRODUCT_REVIEWS_SUCCESS";
export const GET_PRODUCT_REVIEWS_FAILURE = "GET_PRODUCT_REVIEWS_FAILURE";

export const POST_PRODUCT_REVIEWS_REQUEST = "GET_PRODUCT_REVIEWS_REQUEST";
export const POST_PRODUCT_REVIEWS_SUCCESS = "GET_PRODUCT_REVIEWS_SUCCESS";
export const POST_PRODUCT_REVIEWS_FAILURE = "GET_PRODUCT_REVIEWS_FAILURE";

export const GET_RECOMMENDATIONS_REQUEST = "GET_RECOMMENDATIONS_REQUEST";
export const GET_RECOMMENDATIONS_SUCCESS = "GET_RECOMMENDATIONS_SUCCESS";
export const GET_RECOMMENDATIONS_FAILURE = "GET_RECOMMENDATIONS_FAILURE";

export const GET_FROM_SAME_BRAND_REQUEST = "GET_FROM_SAME_BRAND_REQUEST";
export const GET_FROM_SAME_BRAND_SUCCESS = "GET_FROM_SAME_BRAND_SUCCESS";
export const GET_FROM_SAME_BRAND_FAILURE = "GET_FROM_SAME_BRAND_FAILURE";

export const GET_SEARCH_REQUEST = "GET_SEARCH_REQUEST";
export const GET_SEARCH_SUCCESS = "GET_SEARCH_SUCCESS";
export const GET_SEARCH_FAILURE = "GET_SEARCH_FAILURE";

export const GET_PRODUCTS_HOME_REQUEST = "GET_PRODUCTS_HOME_REQUEST";
export const GET_PRODUCTS_HOME_SUCCESS = "GET_PRODUCTS_HOME_SUCCESS";
export const GET_PRODUCTS_HOME_FAILURE = "GET_PRODUCTS_HOME_FAILURE";
